<template>
    <layout v-bind:user="user" v-bind:company="company" title="運営 お知らせ一覧" @selectList="displaySelectedBrand($event)">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>お知らせ一覧</span></div>
                <div class="controller flex _right _y-center">
                    <div>
                        <Link class="btn_link md_icon-text _white" :href="route('admin.create')"><div class="inner">
                            <span>
                                新規作成
                                <div class="icon">
                                    <SvgIconAdd />
                                </div>
                            </span>
                        </div></Link>
                    </div><!--/.add-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->
            <!--ShopList-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="_pointer" @click="clickSort('created_at')">作成日時 {{getTriangle('created_at')}}</th>
                                    <th class="_pointer" @click="clickSort('recipient')">送信先 {{getTriangle('recipient')}}</th>
                                    <th class="_pointer" @click="clickSort('title')">タイトル {{getTriangle('title')}}</th>
                                    <th class="_pointer" @click="clickSort('status')">ステータス {{getTriangle('status')}}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <!--Item-->
                                <tr v-for="n in newsList" :key="n.id">
                                    <td><Link class="ovl" :href="route('admin.create',n.id)"></Link>{{formatDate(n.created_at)}}</td>

                                    <td v-if="n.recipient == 0">全体</td>
                                    <td v-else-if="n.recipient == 1">ショップ</td>
                                    <td v-else-if="n.recipient == 2">ブランド</td>
                                    <td v-else-if="n.recipient == 3">ショールーム</td>

                                    <td>{{n.title}}</td>
                                    <td v-if="n.status == 0">非公開</td><td v-else-if="n.status == 1">公開</td><td v-else-if="n.status == 2">下書き</td>
                                    <td class="icon">
                                        <Link :href="route('admin.create',n.id)">
                                            <div class="btn_svg-icon"><SvgIconEdit /></div>
                                        </Link>
                                    </td>
                                </tr><!--/.Item-->
                            </tbody>
                        </table>
                        <pagination v-if="showPagination" :list="links" />
                    </div><!--/.table_common-->
                </div><!--/.md_common-bl-->
            </div>
            <AlertModal
                v-if="showAlertModal"
                @close="closeAlertModal"
                :title="alert_modal_title"
                :message="alert_modal_message"
                :mode="alert_modal_mode"
            />
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import dayjs from 'dayjs'
    import { Link } from '@inertiajs/inertia-vue3'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'

    import ScrollHint from 'scroll-hint';

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "AlertModal": AlertModal,
            "ScrollHint": ScrollHint,
            SvgIconEdit,
            SvgIconAdd
        },
        data() {
            return {
                showPagination: false,
                links: '',
                showAlertModal: false,
                alert_modal_title: "",
                alert_modal_message: "",
                alert_modal_mode: "",
                list_sorter: {column: "", order: ""}
            }
        },
        props: {
            news: Array,
            user: Object,
            company: Object,
            listSorter: Object,
        },
        mounted() {
            if(this.listSorter){
                this.list_sorter = this.listSorter;
            }
            if(this.$page.props.flash.success?.length > 0){
                const successMessage = this.$page.props.flash.success.split(",");
                this.openAlertModal("success", successMessage[0],  successMessage[1]); // 確認済み
            };
            new ScrollHint('.table_common');
        },
        methods: {
            formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    listSorter: { column, order }
                })
                Inertia.get('news', form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            }
        },
        computed: {
            newsList() {
                if (this.news.data) {
                    this.showPagination = true;
                    this.links = this.news;
                }
                if (this.listSorter) {
                    this.addSorterToLinks(this.listSorter, this.news.links);
                }
                return this.news.data;
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
        }
    }
</script>
